import $ from 'jquery'

export default () => {
  $(() => {
    $('.search .searchform input[name="s"]').on('paste keyup', e => {
      const keywords = $(e.target).val()

      $('.search .searchform input[name="s"]').not(e.target).attr('value', keywords)
      $('.search .searchform input[name="s"]').not(e.target).val(keywords)

      $.get(window.endpoint + '/get-products-by-keywords', {
        /* eslint-disable */
        'posts_per_page': localVar['search_limit'],
        'page': 1,
        'keywords': keywords
      })
        .done(res => {
          console.log(res)
          const html = generateSearchResultItems(res.products)
          $('.search .results ul').html(html)
        })
    })
  })
}

const generateSearchResultItems = items => {
  let html = ''
  items.map(item => html += generateSearchResultItem(item))
  return html
}

const generateSearchResultItem = item => {
  return `<li><a href="${item.url}">${item.title}</a></li>`
}
